module.exports = __webpack_public_path__ + "static/media/32.0ce5c49d.jpg";